
<template>
    <div class="login rows">
        <div class="login_box columns">
           <div class="register_line row">
             <h4>欢迎注册QimMoS+自动化变形监测系统</h4>
             <div class="login_btn rows">
               <b>已有账号?</b>
                <el-button plain size="mini" @click="tologin">登录</el-button>
             </div>
           </div>
  <div class="form_box">

<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="1rem" class="demo-ruleForm" label-position="left" status-icon>
<el-form-item label="用户名" prop="user" auto-complete="off" >
<el-input v-model="ruleForm.user"></el-input>
</el-form-item>
<el-form-item label="密码" prop="psd" auto-complete="off" >
<el-input v-model="ruleForm.psd" type="password"></el-input>
</el-form-item>
<el-form-item label="确认密码" prop="repsd" auto-complete="off" >
<el-input v-model="ruleForm.repsd" type="password"></el-input>
</el-form-item>
</el-form-item>
<el-form-item label="公司名称" prop="company" >
<el-input v-model="ruleForm.company"></el-input>
</el-form-item>
</el-form-item>
<el-form-item label="真实姓名" prop="name">
<el-input v-model="ruleForm.name"></el-input>
</el-form-item>
</el-form-item>
<el-form-item label="电话号码" prop="tel" ref="telForm">
<el-input v-model="ruleForm.tel"></el-input>
</el-form-item>
</el-form-item>
<div class="row">
 <el-form-item label="验证码" prop="code">
<el-input v-model="ruleForm.code" class="code"></el-input>
<el-button @click.prevent="sendcode" :disabled="isres" :loading="isloading">发送验证码</el-button>
</el-form-item>
<span style="font-size:12px;line-height:40px;color:#909399;padding-left:3px" v-show="isloading">{{count}}s</span>
</div>
<el-form-item class="btn">
<el-button type="primary" @click="submitForm('ruleForm')" class="re_btn">注册</el-button>
</el-form-item>
</el-form>

            </div>
        </div>
    </div>
</template>

<style>
.login {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-image: url("../assets/home/subway.jpg");
  z-index: -10;
  /*是背景不要重复  */
  background-repeat: no-repeat;
  /* 让图片随屏幕大小同步缩放，但是有部分可能会被裁切，不过不至于会露白，下面两句是为chrome和opera浏览器作兼容。 */
  background-size: 100% 100%;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: 0 center;
}
.login .el-input{
  width: 305px;
}
.login_box {
  width: 8.4rem;
  height: 6.5rem;
  background: rgba(255, 255, 255, 1);
  border-radius: 0.08rem;
}
.form_box {
  width: 4.3rem;
  height: 100%;
  /* background-color: pink; */
}
.login_box h1 {
  font-size: 0.26rem;
  font-family: MicrosoftYaHei-Bold;
  font-weight: bold;
  color: rgba(67, 148, 208, 1);
  line-height: 0.24rem;
  letter-spacing: 0.2rem;
  margin: 0 auto;
  margin-top: 0.49rem;
  margin-bottom: 0.35rem;
}
.login .el-form-item {
  margin-bottom: 0.18rem;
}
.code {
  width: 1.6rem !important;
  margin-right: 0.27rem;
}
.btn {
  margin-left: -0.65rem;
  margin-top: 0.25rem;
}
.re_btn {
  width: 3.88rem;
  height: 0.42rem;
  background: rgba(67, 148, 208, 1);
  border-radius: 0.04rem;
}
.login .el-button{
 padding: 12px 12px;
}
.register_line{
  width: 80%;
  padding: 10px 10px 20px 10px;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #f4f4f4;
  margin: 40px 0;
}
.register_line h4{
  font-size: 18px;
  font-weight: bold;
  color: rgba(67, 148, 208, 1)
}
.register_line .login_btn b{
  font-size: 12px;
  color: #c3c3c3;
  font-weight: normal;
  padding-right: 5px;
}
.register_line .login_btn b:hover{
   color: rgba(67, 148, 208, 1);
}
.register_line .login_btn .el-button{
  padding: 5px 8px;
}

</style>


<script>
export default {
  data() {
    //验证用户名
    var validateuser = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入用户名"));
      } else if (!/^[a-zA-Z][a-zA-Z0-9_]*$/.test(value)) {
        callback(new Error("用户名只能包括字母,数字与'_',必须以英文字母开头"));
      } else if (value.length > 20 || value.length < 2) {
        callback(new Error("用户名最少2个字符最长不能超过20个字符！"));
      } else {
        this.checkuser(values => {
          if (values == 1) callback();
          else if (values == 2) callback(new Error("输入的文本有误！"));
          else if (values == 3)
            // 校验公司名称是否重复
            callback(new Error("此用户名太受欢迎啦，请更换一个~"));
        });
      }
    };

    // 验证密码
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (!/^[a-zA-Z0-9](?:(?!-)[a-zA-Z0-9_@])*$/.test(value)) {
        callback(new Error("密码格式错误!(以数字或字母开头，不能包含-)"));
      } else if (value.length < 6 || value.length > 20) {
        callback(new Error("密码最少6个字符且不能超过20个字符!"));
      } else {
        // if (this.ruleForm.psd !== "") {
        //   this.$refs.ruleForm.validateField("psd");
        // }
        callback();
      }
    };

    // 验证重新输入密码
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.psd) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };

    //验证公司名称
    var validatecompany = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入公司名称！"));
      } else if (!/^[\u4e00-\u9fa5A-Za-z0-9]{2,20}$/.test(value)) {
        callback(
          new Error(
            "公司名称格式错误(只能包含汉字,字母,数字,最少2个最多20个字符)!"
          )
        );
      } else {
        this.checkcompany(values => {
          if (values == 1) {
            callback();
          } else if (values == 2) {
            callback(new Error("文本错误！"));
          } else if (values == 3) {
            // 校验公司名称是否重复
            callback(new Error("该公司名称已注册过,请更换！"));
          }
        });
      }
    };
    //验证姓名
    var validatename = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入真实姓名！"));
      } else if (!/^[\u4e00-\u9fa5]{2,20}$/.test(value)) {
        callback(new Error("姓名格式输入错误!"));
      } else {
        callback();
      }
    };

    //验证电话号码
    var validatetel = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入您的电话号码!"));
      } else if (!/^1[34578]\d{9}$/.test(value)) {
        callback(new Error("电话号码格式错误"));
      } else {
        this.checktel(values => {
          if (values == 1) callback();
          else if (values == 2) callback(new Error("输入的文本有误！"));
          else if (values == 3)
            // 校验手机号码是否使用过
            callback(new Error("该手机号已被注册,请更换~"));
        });
      }
    };
    //验证验证码
    var validatecode = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("验证码不能为空"));
      } else if (!/^[0-9]*$/.test(value)) {
        callback(new Error("验证码格式错误"));
      } else {
        callback();
      }
    };

    return {
      ruleForm: {
        user: "",
        psd: "",
        repsd: "",
        company: "",
        name: "",
        tel: "",
        code: ""
      },
      rules: {
        user: [{ required: true, validator: validateuser, trigger: "blur" }],
        psd: [{ required: true, validator: validatePass, trigger: "blur" }],
        repsd: [{ required: true, validator: validatePass2, trigger: "blur" }],
        company: [
          { required: true, validator: validatecompany, trigger: "blur" }
        ],
        name: [{ required: true, validator: validatename, trigger: "blur" }],
        tel: [{ required: true, validator: validatetel, trigger: "blur" }],
        code: [{ required: true, validator: validatecode, trigger: "blur" }]
      },
      userfailinfo: "",
      companyfailinfo: "",
      telfailinfo: "",
      codefailinfo: "",
      isres:false,
      isloading:false,
      count:60
    };
  },
     created() {
    //监听页面的enter事件
    var that = this;
    document.onkeydown = function(e) {
      var key = window.event.keyCode;
      if (key == 13) {
         that.submitForm('ruleForm')
      }
    };
  },
  methods: {
    // 监测用户名是否重复
    checkuser(next) {
      this.$axios
        .get("/user/check_username", {
          params: {
            username: this.ruleForm.user
          }
        })
        .then(result => {
          if (result.data.result.type == "success") this.userfailinfo = 1;
          else {
            //成功
            if (result.data.result.failInfo == "type")
              this.userfailinfo = 2; //文本错误
            else this.userfailinfo = 3; //已注册
          }
          next(this.userfailinfo);
        })
        .catch(function(error) {});
    },
    // 监测公司名称是否重复
    checkcompany(next) {
      this.$axios
        .get("/user/check_company", {
          params: {
            name: this.ruleForm.company
          }
        })
        .then(result => {
          if (result.data.result.type == "success") this.companyfailinfo = 1;
          else {
            //成功
            if (result.data.result.failInfo == "type")
              this.companyfailinfo = 2; //文本错误
            else this.companyfailinfo = 3; //已注册
          }
          next(this.companyfailinfo);
        })
        .catch(function(error) {});
    },
    //验证手机号码是否重复
    checktel(next) {
      this.$axios
        .get("/user/check_phone", {
          params: {
            tel: this.ruleForm.tel
          }
        })
        .then(result => {
          if (result.data.result.type == "success") this.telfailinfo = 1;
          else {
            //成功
            if (result.data.result.failInfo == "type")
              this.telfailinfo = 2; //文本错误
            else this.telfailinfo = 3; //已注册
          }
          next(this.telfailinfo);
        })
        .catch(function(error) {});
    },
    // 发送验证码
    sendcode() {
      //手机号码已经被使用时，不能再发送验证码
       this.checktel(values => {
          if (values == 3||this.ruleForm.tel==""){
          // 校验手机号码是否使用过
           
          }else{
            this.isloading=true
            //添加倒计时计时器
            var that=this
            // 每次点击，秒数都回到60s
            that.count=60
            var timer = setInterval (function () { 
            that.count--; 
                // 如果数值小于-1了，就停止计时 
            if (that.count <= 0) {
                  clearInterval(timer); 
                  //清楚按钮转动
                  that.isloading=false
            }
             },1000);

             this.$axios
        .get("/user/sendmsg", {
          params: {
            tel: that.ruleForm.tel
          }
        })
        .then(result => {})
        .catch(function(error) {});

          }         
        });
    },
    //点击登录按钮。回到登录界面
    tologin(){
     this.$router.push("/login");
    },
    // 注册按钮点击触发的事件
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          //对整个表单校验成功的话执行下面
          //把参数传给后端
          this.$axios({
            method: "post",
            url: "/user/register",
            data: {
               username:this.ruleForm.user,
               password:this.ruleForm.psd,
               true_name:this.ruleForm.name,
               name:this.ruleForm.company,
               tel:this.ruleForm.tel,
               code:this.ruleForm.code
            }
          }).then((result) => {
            debugger
            if (result.data.result.type == 'fail'){
              var msgStr = (result.data.result.failInfo == 'code') ? '验证码错误' : result.data.result.failInfo;
              this.$message({
                dangerouslyUseHTMLString: true,
                message: msgStr,
                type: 'error'
              })
            }else{
              // 成功跳转页面
              console.log(result.data.result);
              this.$router.push("/login");
            }
            })
            .catch(function(error) {
               console.log(result.data.result);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
};
</script>





// WEBPACK FOOTER //
// src/register/register.vue